import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const Pulse = (props: SvgProps) => (
  <Svg width={30} height={30} viewBox="0 0 96 96" fill="#FFF" {...props}>
    <Path d="M45.2 13.2c-.8.8-1.2 5.8-1.2 16v14.7l-15.1.3c-13.2.3-15.3.5-16.3 2-.8 1.3-.8 2.3 0 3.5 1 1.6 3.1 1.8 16.2 2.1l15.1.3.3 15.1c.3 13.1.5 15.2 2.1 16.2 1.2.8 2.2.8 3.5 0 1.5-1 1.7-3.1 2-16.2l.3-15.1 15.1-.3c13.1-.3 15.2-.5 16.2-2.1.8-1.2.8-2.2 0-3.5-1-1.5-3.1-1.7-16.3-2L52 43.9V29.2c0-15.1-.5-17.2-4-17.2-.9 0-2.1.5-2.8 1.2z" />
  </Svg>
);
export default Pulse;
